"use client";
import { useTranslations } from "next-intl";
import { useState, useCallback } from "react";
import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";

import Logo from "@/shared/components/Logo";

import arrowOut from "@public/arrow_out.svg";
import closeCross from "@public/close_cross.png";

import { PATHS } from "@/shared/utils/paths";

import s from "./styles.module.css";

export default function FloatingGetWallet() {
  const t = useTranslations("FloatingGetWallet");
  const [isOpen, setIsOpen] = useState(true);

  const onClose = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsOpen(false);
  }, []);

  return (
    <Link
      href={PATHS.wallet}
      className={clsx(s.container, !isOpen && s.closed)}
    >
      <div className={s.texts}>
        <button className={s.closeButton} onClick={onClose}>
          <Image src={closeCross} width={24} height={24} alt="close cross" />
        </button>
        <h6 className={s.title}>{t("title")}</h6>
        <div className={s.description}>
          {t("description")}
          <Image
            width={8}
            className={s.arrow}
            src={arrowOut}
            alt="arrow external link"
          />
        </div>
      </div>
      <Logo type="square" className={s.logo} />
    </Link>
  );
}
